<template>
  <div class="form-gcp-machine">
    <v-row>
      <v-col cols="9">
        <v-text-field
          label="Plataforma"
          type="text"
          readonly
          value="Google Cloud Platform"
        />
      </v-col>
      <v-col cols="3">
        <v-btn
          text
          small
          color="error"
          v-on:click="removeMachine()"
        >
          <v-icon left>
            mdi-delete
          </v-icon>
          Remover
        </v-btn>
      </v-col>
    </v-row>
    <ValidationProvider name="name" rules="required" v-slot="{ errors }">
      <v-text-field
        label="Nome"
        type="text"
        v-model="machine.name"
        :error-messages="errors"
        filled
        required
      />
    </ValidationProvider>
    <ValidationProvider name="image" rules="required" v-slot="{ errors }">
      <v-select
        v-model="machine.gcp.image"
        :error-messages="errors"
        :items="images"
        item-text="description"
        item-value="name"
        label="Imagem (SO)"
        filled
        required
      ></v-select>
    </ValidationProvider>
    <ValidationProvider name="zone" rules="required" v-slot="{ errors }">
      <v-select
        v-model="machine.gcp.zone"
        @change="zoneSelected()"
        :error-messages="errors"
        :items="zones"
        item-text="description"
        item-value="name"
        label="Zona"
        filled
        required
      ></v-select>
    </ValidationProvider>
    <ValidationProvider name="type" rules="required" v-slot="{ errors }">
      <v-select
        v-model="machine.gcp.type"
        :error-messages="errors"
        :items="machineTypes"
        item-text="name"
        item-value="name"
        label="Tipo"
        filled
        required
      ></v-select>
    </ValidationProvider>
    <v-row>
      <v-col cols="4">
        <ValidationProvider name="enableIntegrityMonitoring">
          <v-switch
            v-model="machine.gcp.enableIntegrityMonitoring"
            label="Integrity monitoring"
            filled
          ></v-switch>
        </ValidationProvider>
      </v-col>
      <v-col cols="4">
        <ValidationProvider name="enableSecureBoot">
          <v-switch
            v-model="machine.gcp.enableSecureBoot"
            label="Secure boot"
            filled
          ></v-switch>
        </ValidationProvider>
      </v-col>
      <v-col cols="4">
        <ValidationProvider name="enableVtpm">
          <v-switch
            v-model="machine.gcp.enableVtpm"
            label="VTPM"
            filled
          ></v-switch>
        </ValidationProvider>
      </v-col>
    </v-row>
    <v-row class="my-5">
      <v-col cols="6">
        <h4 class="mb-2">Discos</h4>
        <div :key="index" v-for="(disk, index) in machine.gcp.disks">
          <v-row>
            <v-col cols="9">
              <ValidationProvider name="boot">
                <v-switch
                  v-model="disk.boot"
                  label="Boot"
                  filled
                ></v-switch>
              </ValidationProvider>
              <ValidationProvider name="autoDelete">
                <v-switch
                  v-model="disk.autoDelete"
                  label="Remover ao apagar"
                  filled
                ></v-switch>
              </ValidationProvider>
            </v-col>
            <v-col cols="3">
              <v-btn
                text
                color="error"
                v-on:click="removeDisk(index)"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <ValidationProvider name="size" rules="required" v-slot="{ errors }">
            <v-text-field
              label="Tamanho (GB)"
              type="number"
              v-model="disk.size"
              :error-messages="errors"
              filled
              required
            />
          </ValidationProvider>
          <ValidationProvider name="type" rules="required" v-slot="{ errors }">
            <v-select
              v-model="disk.type"
              :error-messages="errors"
              :items="diskTypes"
              item-text="description"
              item-value="name"
              label="Tipo"
              filled
              required
            ></v-select>
          </ValidationProvider>
          <v-divider class="my-2"></v-divider>
        </div>
        <v-btn
          tile
          color="success"
          class="mt-5"
          v-on:click="addDisk()"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Novo disco
        </v-btn>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="6">
        <h4 class="mb-2">Interfaces de rede</h4>
        <div :key="index" v-for="(network, index) in machine.gcp.networks">
          <v-row class="mb-1">
            <v-col cols="9">
            </v-col>
            <v-col cols="3">
              <v-btn
                text
                color="error"
                v-on:click="removeNetwork(index)"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <v-select
              v-model="network.name"
              :error-messages="errors"
              :items="networks"
              item-text="name"
              item-value="name"
              label="Nome"
              filled
              required
            ></v-select>
          </ValidationProvider>
          <ValidationProvider name="networkIp" v-slot="{ errors }">
            <v-select
              v-model="network.networkIp"
              :error-messages="errors"
              :items="networksIp"
              item-text="name"
              item-value="value"
              label="IP Externo"
              filled
            ></v-select>
          </ValidationProvider>
          <v-divider class="my-2"></v-divider>
        </div>
        <v-btn
          tile
          color="success"
          class="mt-5"
          v-on:click="addNetwork()"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Nova interface
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GcpService from '@/services/gcp/gcp.service';
import AdminMachineService from "@/services/admin-machine/admin-machine.service";

const gcpService = new GcpService();
const adminMachineService = new AdminMachineService();

export default {
  name: 'FormGcpMachine',
  emits: ['remove'],
  props: {
    courseId: String,
    machine: Object,
  },
  data: () => ({
    images: [],
    zones: [],
    machineTypes: [],
    diskTypes: [],
    networks: [
      {
        name: 'vpc4cloud',
      },
      {
        name: 'vpc4cloudinternal',
      },
    ],
    networksIp: [
      {
        name: 'IP Automático',
        value: '',
      },
      {
        name: 'Sem IP',
        value: 'noIp',
      },
    ],
  }),
  mounted() {
    gcpService.getZones()
      .then((response) => this.zones = response.data);

    gcpService.getImages()
      .then((response) => this.images = response.data);

    if (this.machine.gcp.zone && this.machine.gcp.zone.length) {
      this.zoneSelected();
    }
  },
  methods: {
    removeMachine() {
      if (this.machine.id.length) {
        adminMachineService.removeMachine(this.courseId, this.machine.id)
          .then((response) => {
             //
          });
      }

      this.$emit('remove');
    },
    removeDisk(index) {
      this.machine.gcp.disks.splice(index, 1);
    },
    removeNetwork(index) {
      this.machine.gcp.networks.splice(index, 1);
    },
    addDisk() {
      this.machine.gcp.disks.push({
        boot: false,
        autoDelete: true,
        size: 10,
        type: 'pd-standard',
      });
    },
    addNetwork() {
      this.machine.gcp.networks.push({
        name: 'vpc4cloudinternal',
        networkIp: 'noIp',
      });
    },
    zoneSelected() {
      gcpService.getMachineTypes(this.machine.gcp.zone)
        .then((response) => this.machineTypes = response.data);

      gcpService.getDiskTypes(this.machine.gcp.zone)
        .then((response) => this.diskTypes = response.data);
    },
  },
};
</script>

<style scoped>

</style>
